import { useContext } from "react";
import { AppContext } from "../App";
import { LegalTexts } from "./LegalTexts";
import { t } from "../i18n";
import { Icon } from "../components/Icon";
import PhoneLabel from "./PhoneLabel";

export const PopupClientEdit = (props) => {
	const {
		flow,
		data,
		setData,
		popUpClientEdit,
		closePopUpClientEdit,
		errors,
		validateForm,
	} = useContext(AppContext);

	const updateData = () => {
		if (!validateForm()) {
			// console.log("Formulario con errores, deteniendo navegación...");
			return;
		}

		let apiUrl = process.env.REACT_APP_API_URL || "http://localhost:3000";
		let token = process.env.REACT_APP_API_TOKEN;

		let controller = new AbortController();
		let options = {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				...data,
				token,
			}),
			signal: controller.signal,
		};

		fetch(`${apiUrl}/bookings/${data.locator}`, options)
			.then((res) => res.json())
			.then((newData) => {
				// console.log(newData);
			})
			.catch((err) => {
				console.error(err);
			})
			.finally(() => {
				controller.abort();
			});

		closePopUpClientEdit();
	};

	return (
		<div
			className={
				"popup_client_edit kensei_02" +
				(popUpClientEdit ? " isActive" : "")
			}
		>
			<div className="popup_client_edit_content">
				<button
					onPointerDown={closePopUpClientEdit}
					className="popup_client_edit_close"
				>
					<img
						className="popup_client_edit_icon"
						src="resources/icons/close.svg"
						alt="Cerrar"
					/>
				</button>
				<div className="popup_client_edit_body">
					<h2>{t("Datos cliente")}</h2>
					<form>
						<label>
							<strong>{t("Nombre y Apellidos")}</strong>
							<input
								type="text"
								defaultValue={data ? data.name : ""}
								onChange={(e) =>
									setData((prev) => ({
										...prev,
										name: e.target.value,
									}))
								}
							/>
							{errors.name && (
								<span className="error">{errors.name}</span>
							)}
						</label>
						<PhoneLabel />
						{flow === "mapfre" && (
							<label>
								<strong>{t("Email")}</strong>
								<input
									type="email"
									defaultValue={data ? data.email : ""}
									onChange={(e) =>
										setData((prev) => ({
											...prev,
											email: e.target.value,
										}))
									}
								/>
								{errors.email && (
									<span className="error">
										{errors.email}
									</span>
								)}
							</label>
						)}
					</form>
					<button
						onPointerDown={updateData}
						className={
							"nav_next" +
							(!data.name || !data.phone ? " disabled" : "")
						}
						href="/#"
					>
						<Icon name="update" className="footer_icon" />
						<p className="footer_p">{t("Actualizar datos")}</p>
					</button>
					<LegalTexts />
				</div>
			</div>
		</div>
	);
};
